export default __webpack_public_path__ + "static/media/Sekhmet.88801d9b.jpg";